import { render, staticRenderFns } from "./FormActionButtons.vue?vue&type=template&id=092c4674&"
import script from "./FormActionButtons.vue?vue&type=script&lang=js&"
export * from "./FormActionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('092c4674')) {
      api.createRecord('092c4674', component.options)
    } else {
      api.reload('092c4674', component.options)
    }
    module.hot.accept("./FormActionButtons.vue?vue&type=template&id=092c4674&", function () {
      api.rerender('092c4674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/61980520-8/components/FormActionButtons.vue"
export default component.exports